const InstituteRankings = [
    {
        header: "Ranking over the years",
        data: [
            { title: "Rank 2023", value: "21" },
            { title: "Rank 2022", value: "22" },
     
        ]
    },
];

export default InstituteRankings;
